import { render, staticRenderFns } from "./new-attendance-modal.component.vue?vue&type=template&id=6df9e559&scoped=true&"
import script from "./new-attendance-modal.component.vue?vue&type=script&lang=ts&"
export * from "./new-attendance-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./new-attendance-modal.component.vue?vue&type=style&index=0&id=6df9e559&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df9e559",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAutocomplete,VForm,VProgressCircular})
